// ---------- 多语言资源（中文 / English） ----------
// 客户提供的《部件英文名标准表》(2026-10-15)：部件英文名以它为标准答案，优先级最高。
// 具体见 src/part-glossary.js，以及文件末尾的 enDisplayName() / enPartNameFallback()。
import { PART_GLOSSARY_EN } from './part-glossary.js'

export const TRANSLATIONS = {
  'brand.name': { zh: 'OBAIR 欧博数字展厅', en: 'OBAIR Digital Showroom' },
  'loading.title': { zh: '欧博数字展厅', en: 'OBAIR Digital Showroom' },
  'loading.loading': { zh: '正在加载展厅模型…', en: 'Loading showroom…' },
  // 电脑端提示（触屏设备换成 hint.rotateTouch 那套手指说法）
  'hint.rotate': { zh: '左键拖动旋转 · 中键拖动平移 · 滚轮缩放 · 点击展品查看详情', en: 'Left-drag to rotate · Middle-drag to pan · Scroll to zoom · Click exhibits for details' },
  // 手机/平板：展厅和弹窗用同一套文案
  'hint.rotateTouch': { zh: '单指拖动旋转 · 双指缩放', en: 'Drag to rotate · Pinch to zoom' },
  'map.title': { zh: '展厅分区导航', en: 'Zone Navigation' },
  'map.home': { zh: '回到入口', en: 'Back to Lobby' },
  'map.floorplan': { zh: '展厅分区导航', en: 'Zone Navigation' },
  'map.close': { zh: '关闭', en: 'Close' },
  'lang.zh': { zh: '中', en: '中' },
  'lang.en': { zh: 'EN', en: 'EN' },
  'site.download': { zh: '资料下载', en: 'Downloads' },
  // 展品名称开关（入口界面右上角按钮）
  'site.exhibitNames': { zh: '展品名称', en: 'Exhibit Names' },
  'site.exhibitNamesHint': { zh: '显示 / 隐藏展品名称', en: 'Show / hide exhibit names' },
  'site.exhibitNamesOn': { zh: '已显示展品名称', en: 'Exhibit names shown' },
  'site.exhibitNamesOff': { zh: '已隐藏展品名称', en: 'Exhibit names hidden' },
  'site.promoVideo': { zh: '企业宣传视频', en: 'Company Video' },
  'promo.title': { zh: '企业宣传视频', en: 'Company Video' },
  'promo.missing': {
    zh: '视频还没有放进来。\n请把文件放到：\npublic/videos/company/promo-zh.mp4 （中文）\npublic/videos/company/promo-en.mp4 （英文）\n放好后刷新页面；若仍看不到，重启一下开发服务器。',
    en: 'Video not found.\nPut the files here:\npublic/videos/company/promo-zh.mp4 (Chinese)\npublic/videos/company/promo-en.mp4 (English)\nThen refresh; if it still fails, restart the dev server.'
  },
  'site.contact': { zh: '联系我们', en: 'Contact' },
  'site.fullscreen': { zh: '全屏', en: 'Fullscreen' },
  // 画质选择按钮
  'quality.auto': { zh: '自动', en: 'Auto' },
  'quality.high': { zh: '高', en: 'High' },
  'quality.mid': { zh: '中', en: 'Mid' },
  'quality.low': { zh: '低', en: 'Low' },
  'quality.label': { zh: '画质', en: 'Quality' },
  'site.downloadTitle': { zh: '资料下载', en: 'Downloads' },
  'site.downloadEmpty': { zh: '暂无下载资料', en: 'No downloads available' },
  'site.openPdf': { zh: '打开', en: 'Open' },
  'site.downloadPdf': { zh: '下载', en: 'Download' },
  'site.downloadFail': { zh: '资料加载失败，请稍后重试', en: 'Failed to load downloads. Please try again.' },
  'site.dmHint': { zh: '左右滑动选择要查看的资料', en: 'Swipe to browse downloads' },
  'contact.email': { zh: '邮箱', en: 'Email' },
  'contact.phone': { zh: '电话', en: 'Phone' },
  'contact.wechat': { zh: '微信', en: 'WeChat' },
  'contact.tiktok': { zh: 'TikTok', en: 'TikTok' },
  'contact.douyin': { zh: '抖音', en: 'Douyin' },
  'contact.instagram': { zh: 'Instagram', en: 'Instagram' },
  'contact.whatsapp': { zh: 'WhatsApp', en: 'WhatsApp' },
  'contact.youtube': { zh: 'YouTube', en: 'YouTube' },
  'contact.linkedin': { zh: '领英', en: 'LinkedIn' },
  'contact.x': { zh: 'X', en: 'X' },
  'contact.website': { zh: '官网', en: 'Official Website' },
  'contact.address': { zh: '地址', en: 'Address' },
  'contact.copyAddress': { zh: '复制地址', en: 'Copy Address' },
  'contact.addressCopied': { zh: '地址已复制', en: 'Address copied' },
  'contact.qrTip': { zh: '打开微信“扫一扫”添加好友', en: 'Scan with WeChat to add us' },
  'contact.qrMissing': { zh: '二维码图片待提供：请保存为 images/contact/wechat-qr.png', en: 'QR image not ready: save it as images/contact/wechat-qr.png' },
  'contact.unset': { zh: '联系方式待配置', en: 'Contact info not configured yet' },
  'contact.copied': { zh: '微信号已复制', en: 'WeChat ID copied' },
  'kb.title': { zh: '小欧 · 智能客服', en: 'AIRA · AI Assistant' },
  'kb.placeholder': { zh: '输入你的问题，例如：有哪些风机盘管产品？', en: 'Ask a question, e.g. What fan coil units do you offer?' },
  'kb.send': { zh: '发送', en: 'Send' },
  'kb.thinking': { zh: '正在检索知识库并生成回答…', en: 'Searching knowledge base…' },
  'kb.fail': { zh: '请求失败，请稍后重试', en: 'Request failed. Please try again.' },
  'kb.sources': { zh: '参考来源', en: 'Sources' },
  'kb.welcome': { zh: '您好！我是小欧，可以问我关于产品、参数和应用场景的问题。', en: 'Hi! I am AIRA. Ask me about our products, specs and applications.' },
  'kb.files': { zh: '资料下载', en: 'Downloads' },
  'kb.close': { zh: '关闭', en: 'Close' },
  'kb.minimize': { zh: '最小化', en: 'Minimize' },
  'kb.maximize': { zh: '最大化', en: 'Maximize' },
  'kb.restore': { zh: '还原', en: 'Restore' },
  'kb.resize': { zh: '拖动改变大小', en: 'Drag to resize' },
  'kb.assistant': { zh: '智能助手', en: 'AI Assistant' },
  // 编辑工具栏
  'pf.editLayer': { zh: '编辑图层', en: 'Edit Layers' },
  'pf.addText': { zh: '＋文字', en: '+ Text' },
  'pf.addImage': { zh: '＋图片', en: '+ Image' },
  'pf.freeze': { zh: '文字转图片', en: 'Text to Image' },
  'pf.save': { zh: '保存', en: 'Save' },
  'pf.del': { zh: '删除', en: 'Delete' },
  'pf.done': { zh: '完成', en: 'Done' },
  'pf.explode': { zh: '爆炸图分解', en: 'Explosive' },
  'pf.text': { zh: '文字', en: 'Text' },
  'pf.edit': { zh: '编辑', en: 'Edit' },
  'pf.color': { zh: '颜色', en: 'Color' },
  'pf.size': { zh: '字号', en: 'Font Size' },
  'pf.font': { zh: '字体', en: 'Font' },
  // 弹窗
  'pf.video': { zh: '产品视频', en: 'Product Video' },
  'pf.chooseVideo': { zh: '选择视频', en: 'Select Video' },
  'pf.cancel': { zh: '取消', en: 'Cancel' },
  'pf.addTextTitle': { zh: '添加文字', en: 'Add Text' },
  'pf.ok': { zh: '确定', en: 'OK' },
  'pf.pdf': { zh: '产品手册', en: 'Manual' },
  'pf.intro': { zh: '产品简介', en: 'Product Intro' },
  'pf.introTitleSuffix': { zh: '产品简介', en: 'Product Intro' },
  'pf.noVideo': { zh: '该产品暂无视频', en: 'No video for this product' },
  'pf.noExplode': { zh: '暂无分解演示', en: 'No exploded view available' },
  'pf.noPdf': { zh: '该产品暂无产品手册', en: 'No manual for this product' },
  'pf.guide': { zh: '点击两侧按钮查看相应信息', en: 'Click the buttons on both sides for more information' },
  // 弹窗页的操作提示：电脑和手机/平板分开写（鼠标 vs 手指）
  'pf.guideOpsMouse': { zh: '按住左键拖动旋转模型 · 中键拖动平移 · 滚轮缩放', en: 'Hold left button to rotate · Middle-drag to pan · Scroll to zoom' },
  'pf.guideOpsTouch': { zh: '单指拖动旋转 · 双指缩放', en: 'Drag to rotate · Pinch to zoom' },
  'pf.saved': { zh: '已保存到产品 ', en: 'Saved to product ' },
  'pf.savedSuffix': { zh: ' 的页面（所有设备可见）', en: ' page (visible on all devices)' },
  'rotate.hint': { zh: '请旋转手机至横屏\n获得最佳展厅体验', en: 'Rotate your phone to landscape\nfor the best experience' },
  'explode.title': { zh: '爆炸图', en: 'Explosive' },
  'explode.back': { zh: '返回弹窗', en: 'Back' },
  'explode.collapse': { zh: '还原', en: 'Restore' },
  'explode.all': { zh: '全部爆炸', en: 'Explode All' },
  'explode.reset': { zh: '重置视角', en: 'Reset View' },
  'explode.controls': { zh: '爆炸控制', en: 'Explosion Controls' },
  'explode.strength': { zh: '爆炸强度', en: 'Explosion Strength' },
  'explode.radial': { zh: '径向', en: 'Radial' },
  'explode.axisX': { zh: 'X 轴', en: 'X Axis' },
  'explode.axisY': { zh: 'Y 轴', en: 'Y Axis' },
  'explode.axisZ': { zh: 'Z 轴', en: 'Z Axis' },
  'explode.display': { zh: '显示', en: 'Display' },
  'explode.autoRotate': { zh: '自动旋转', en: 'Auto Rotate' },
  'explode.partLabels': { zh: '部件编号', en: 'Part Labels' },
  'explode.partColor': { zh: '部件分色', en: 'Part Colors' },
  'explode.operations': { zh: '操作', en: 'Controls' },
  'explode.hint': { zh: '左键拖动旋转 · 右键平移 · 滚轮缩放\n悬停红色高亮，点击部件或列表项可聚焦', en: 'Drag to rotate · Right-drag to pan · Scroll to zoom\nHover to highlight, click a part or list item to focus' },
  'explode.parts': { zh: '部件', en: 'Parts' },
  'explode.loading': { zh: '正在加载模型…', en: 'Loading model…' },
  'fps.title': { zh: '开发用帧率', en: 'FPS (dev)' }
}

export const ZONE_NAMES_EN = {
  1: 'Centrifugal',
  2: 'Integrated',
  3: 'DX Units\nHydraulic',   // 地图上分两行显示
  4: 'Air-side',
  5: 'Plant Tour',
  6: 'Company\nIntroduction',   // 地图上分两行显示
  7: 'Scroll',
  8: 'Screw'
}

// 部件名映射（爆炸图列表）：中文根词 → 英文
export const PART_NAMES_EN = {
  'U型铜管': 'U-Bend Copper Tube',
  '侧板': 'Side Panel',
  '外壳体': 'Casing',
  '平面': 'Plane',
  '弯头': 'Elbow',
  '接线盒': 'Junction Box',
  '水头': 'Pipe Connection',
  '水盘': 'Drain Pan',
  '电机': 'Motor',
  '电机底座': 'Motor Bracket',
  '盘管侧板': 'Coil Side Panel',
  '盘管底板': 'Coil Bottom Plate',
  '翅片': 'Fin',
  '轴': 'Shaft',
  '顶板': 'Top Plate',
  '风扇': 'Fan',
  '风机零件': 'Fan Part',
  '风车架板': 'Fan Frame Plate',
  '风机盘管': 'Fan Coil Unit',
  '风机': 'Supply Fan',
  '盘管': 'Coil',
  '铜管': 'Copper Tube',
  '底座': 'Base',
  '导流圈': 'Guide Ring',
  '固定板': 'Fix Plate',
  '安装板': 'Mount Plate',
  '支架': 'Bracket',
  '钣金': 'Sheet Metal',
  '端盖': 'End Cover',
  '法兰': 'Flange',
  '轴承': 'Bearing',
  '螺钉': 'Screw',
  '螺栓': 'Bolt',
  '螺母': 'Nut',
  '垫片': 'Washer',
  '密封圈': 'Seal Ring',
  '保温层': 'Insulation',
  '壳体': 'Housing',
  '面板': 'Panel',
  '底板': 'Bottom Plate',
  '顶盖': 'Top Cover',
  '换热器': 'Heat Exchanger',
  '压缩机': 'Compressor',
  '控制器': 'Controller',
  '传感器': 'Sensor',
  '阀': 'Valve',
  '分液头': 'Distributor',
  '回气管': 'Return Tube',
  '排气管': 'Discharge Tube',
  '毛细管': 'Capillary Tube',
  // 47 柜式风盘模型部件
  '正压板条45°-45°': 'Positive Pressure Slat 45°-45°',
  '正压板条45°-90°': 'Positive Pressure Slat 45°-90°',
  '正压板条90°-45°': 'Positive Pressure Slat 90°-45°',
  '正压板条90°-90°': 'Positive Pressure Slat 90°-90°',
  '负压板条45°-45°': 'Negative Pressure Slat 45°-45°',
  '负压板条45°-90°': 'Negative Pressure Slat 45°-90°',
  '负压板条90°-45°': 'Negative Pressure Slat 90°-45°',
  '负压板条90°-90°': 'Negative Pressure Slat 90°-90°',
  '主梁': 'Main Beam',
  '辅梁': 'Auxiliary Beam',
  '横梁': 'Cross Beam',
  '纵梁': 'Longitudinal Beam',
  '整板门压扣': 'Door Panel Latch',
  '整板门压扣001': 'Door Panel Latch',
  '整板门压扣001001': 'Door Panel Latch',
  '整板门压扣001002': 'Door Panel Latch',
  '整板门压扣001003': 'Door Panel Latch',
  '整板门把手': 'Door Panel Handle',
  '整板门483': 'Door Panel 483',
  '整板门483-523': 'Door Panel 483-523',
  '整板门包边485-45°-45°': 'Door Panel Edge Trim 485 (45°-45°)',
  '整板门包边525-45°-45°': 'Door Panel Edge Trim 525 (45°-45°)',
  '面板489': 'Panel 489',
  '面板489-529': 'Panel 489-529',
  '面板1014': 'Panel 1014',
  '面板1014-529': 'Panel 1014-529',
  '面板1014-1364': 'Panel 1014-1364',
  '面板1014-1364001': 'Panel 1014-1364',
  '面板1364': 'Panel 1364',
  '面板1364-529': 'Panel 1364-529',
  '三通-配25mm面板': 'Tee Connector - 25mm Panel',
  '直通-配25mm面板': 'Straight Connector - 25mm Panel',
  '加强筋固定块': 'Stiffener Fixing Block',
  '尼龙网': 'Nylon Mesh',
  '尼龙网框架加强筋': 'Nylon Mesh Frame Stiffener',
  '左右挡板': 'Left/Right Baffle Plate',
  '滑槽': 'Slide Channel',
  '接线盒150-100': 'Junction Box 150x100',
  '5#方通': 'No.5 Square Tube',
  '5#槽钢': 'No.5 Channel Steel',
  '水盘排水口': 'Drain Pan Outlet',
  'SYT10-10L风机': 'SYT10-10L Fan',
  '盘管001': 'Coil',
  '盘管002': 'Coil',
  '管路密封圈': 'Pipe Seal Ring',
  '风口包边': 'Air Outlet Edge Trim',
  '风口法兰梁': 'Air Outlet Flange Beam',
  'LOGO': 'Logo',
  // 34 BF-380 箱式通风机组部件
  '左右面板': 'Left/Right Panel',
  '底座支撑梁': 'Base Support Beam',
  '电机支撑梁': 'Motor Support Beam',
  '角立柱': 'Corner Column',
  '送风面板': 'Supply Air Panel',
  '顶底面板': 'Top/Bottom Panel',
  '风机.': 'Fan',
  '风机支撑梁': 'Fan Support Beam'
}

// 产品名映射（弹窗/爆炸图标题等）：中文名 → 英文名
export const PRODUCT_NAMES_EN = {
  'FP-119WA风机盘管': 'FP-119WA Fan Coil Unit',
  '风机盘管': 'Fan Coil Unit',
  '箱式通风机组': 'Box Type Ventilation Unit',
  '风冷涡旋式冷（热）水机组': 'Air-Cooled Scroll Chiller Heat Pump Unit',
  '气悬浮变频离心式水冷冷水机组': 'Air Suspension Variable Frequency Centrifugal Water-Cooled Chiller',
  '模块式气悬浮变频离心式冷水机组': 'Modular Air-Suspension Variable-Frequency Centrifugal Chiller',
  '磁悬浮变频离心式水冷冷水机组': 'Magnetic Levitation Variable Frequency Centrifugal Water-Cooled Chiller',
  '模块式水冷冷水机组': 'Modular Water-Cooled Scroll Chiller',
  '一体式水冷螺杆冷水机组': 'Integrated Water-Cooled Screw Chiller',
  '一体式蒸发冷冷水机组': 'All-in-one Evaporative Chiller',
  '一体式蒸发冷螺杆冷水机组': 'All-in-One Evaporative Screw Chiller',
  '一体式蒸发冷螺杆热泵机组': 'All-in-One Evaporative Screw Heat Pump Unit',
  '一体式蒸发冷磁悬浮冷水机组': 'All-in-One Evaporative Magnetic Levitation Chiller',
  '一体式蒸发冷气悬浮冷水机组': 'All-in-One Evaporative Air-Suspension Chiller',
  '一体式蒸发冷热泵机组': 'All-in-One Evaporative Heat Pump Unit',
  '直膨式空气调节机组': 'Direct Expansion Air Handling Unit',
  '水力模块': 'Hydraulic Kit',
  '冷凝排风热回收新风空调机组': 'Condensing Exhaust Heat Recovery Fresh Air Handling Unit',
  '大空间专用空调机组': 'Specialized Direct Expansion Air Conditioning Unit for Large Spaces',
  '组合式空调机组': 'Modular Air Handling Unit',
  '洁净手术室用空气调节机组': 'Medical Direct Expansion Air Handling Unit',
  '转轮除湿段': 'Desiccant Wheel Dehumidification Section',
  '新风换气机组': 'Fresh Air Ventilation Unit',
  '低温空气源热泵机组': 'Low-Temperature Air-Source Heat Pump Unit',
  '四管制模块式风冷热泵机组': 'Four-Pipe Modular Air-Cooled Heat Pump Unit',
  '模块式风冷冷水（热泵）机组': 'Modular Air-Cooled Scroll Chiller Heat Pump Unit',
  '四管制风冷螺杆热泵机组': 'Four-Pipe Air-Cooled Screw Heat Pump Unit',
  '变频满液式水冷螺杆冷水机组': 'Variable Frequency Flooded Evaporator Water-Cooled Screw Chiller',
  '满液式水冷螺杆冷水机组': 'Flooded Evaporator Water-Cooled Screw Chiller',
  '螺杆式水冷低温冷冻机组': 'Screw-Type Water-Cooled Low-Temperature Chiller',
  '满液式水（地）源热泵机组': 'Full-Flow Water Ground Source Heat Pump Unit',
  '风冷螺杆式冷水（热泵）机组': 'Air-Cooled Screw Chiller Heat Pump Unit',
  '柜式风机盘管机组': 'Cabinet Fan Coil Unit',
  '卧式风机盘管': 'Horizontal Fan Coil Unit',
  '卡式风机盘管': 'Fan Coil Unit'
}

// 建模特征/通用词组翻译（SolidWorks 特征树导出模型用，长词优先匹配）
export const FEATURE_WORDS_EN = {
  'U形': 'U-Shape',
  '实体-移动复制': 'Solid Move/Copy',
  '电子膨胀阀': 'Electronic Expansion Valve',
  '电磁四通换向阀': 'Four-Way Reversing Solenoid Valve',
  '四通阀': 'Four-Way Valve',
  '电磁阀': 'Solenoid Valve',
  '单向阀': 'Check Valve',
  '截止阀': 'Stop Valve',
  '安全阀': 'Safety Valve',
  '角阀': 'Angle Valve',
  '球阀': 'Ball Valve',
  '蝶阀': 'Butterfly Valve',
  '排气阀': 'Air Vent Valve',
  '膨胀阀': 'Expansion Valve',
  '止回阀': 'Check Valve',
  '过滤器': 'Filter',
  '油过滤器': 'Oil Filter',
  '干燥过滤筒': 'Dryer Filter Shell',
  '干燥过滤器': 'Dryer Filter',
  '铜过滤器': 'Copper Filter',
  '初效过滤器': 'Pre-efficiency Filter',
  '中效过滤器': 'Medium Efficiency Filter',
  '袋式过滤器': 'Bag Filter',
  '水过滤器': 'Water Filter',
  '油分离器': 'Oil Separator',
  '油分': 'Oil Separator',
  '气液分离器': 'Accumulator',
  '储液器': 'Liquid Receiver',
  '储液罐': 'Liquid Receiver Tank',
  '气分': 'Accumulator',
  '膨胀罐': 'Expansion Tank',
  '平衡罐': 'Balance Tank',
  '集气管': 'Gas Header',
  '分液桶': 'Distributor Drum',
  '分液管': 'Distributor Tube',
  '吸气管': 'Suction Tube',
  '回气管': 'Return Tube',
  '排气管': 'Discharge Tube',
  '液管': 'Liquid Tube',
  '冷媒管': 'Refrigerant Tube',
  '进液管': 'Liquid Inlet Tube',
  '冷却管': 'Cooling Tube',
  '铜管夹': 'Copper Tube Clamp',
  '管夹': 'Tube Clamp',
  '铜管': 'Copper Tube',
  '直铜管': 'Straight Copper Tube',
  '无缝钢管': 'Seamless Steel Pipe',
  '钢管': 'Steel Pipe',
  '折弯铜管': 'Bent Copper Tube',
  '铜弯头': 'Copper Elbow',
  '钢弯头': 'Steel Elbow',
  '变径': 'Reducer',
  '铜变径': 'Copper Reducer',
  '钢变径': 'Steel Reducer',
  '异径': 'Reducing',
  '等径三通': 'Equal Tee',
  '异径三通': 'Reducing Tee',
  '三通': 'Tee',
  '弯头': 'Elbow',
  '接头': 'Joint',
  '接头座': 'Joint Seat',
  '转接头': 'Adapter',
  '转接接头': 'Adapter Joint',
  '螺纹接头': 'Threaded Joint',
  '直接头': 'Straight Joint',
  '接管': 'Connector Tube',
  '卡箍': 'Clamp',
  '管卡': 'Pipe Clamp',
  '螺母': 'Nut',
  '垫片': 'Washer',
  '螺栓': 'Bolt',
  '螺钉': 'Screw',
  '法兰': 'Flange',
  '压缩机': 'Compressor',
  '双螺杆': 'Twin-Screw',
  '单螺杆': 'Single-Screw',
  '螺杆': 'Screw',
  '螺杆式': 'Screw-Type',
  '涡旋': 'Scroll',
  '气悬浮': 'Air-Suspended',
  '壳管式': 'Shell-and-Tube',
  '蒸发式': 'Evaporative',
  '干式': 'Dry Expansion',
  '满液式': 'Flooded',
  '螺杆式压缩机': 'Screw Compressor',
  '螺杆压缩机': 'Screw Compressor',
  '涡旋压缩机': 'Scroll Compressor',
  '冷凝器': 'Condenser',
  '蒸发器': 'Evaporator',
  '壳管冷凝器': 'Shell-and-Tube Condenser',
  '壳管蒸发器': 'Shell-and-Tube Evaporator',
  '表冷器': 'Cooling Coil',
  '初-中效过滤器组件': 'Pre & Medium Filter Assembly',
  '亚高效过滤器组件': 'Sub-high Efficiency Filter Assembly',
  '前段盘管挡风板': 'Front Coil Baffle Plate',
  '后段盘管挡风板': 'Coil Baffle Plate Assembly (Downstream Side)',
  '前段表冷器组件': 'Front Cooling Coil Assembly',
  '后段表冷器组件': 'Rear Cooling Coil Assembly',
  '均流网组件': 'Flow Equalizing Screen Assembly',
  '壳管式蒸发器': 'Shell-and-Tube Evaporator',
  '气液分离器': 'Accumulator',
  '电子膨胀阀': 'Electronic Expansion Valve',
  '高效罐': 'High-Efficiency Tank',
  '壳管蒸发器': 'Shell-and-Tube Evaporator',
  '电风机组件': 'Electric Fan Assembly',
  '再生风机': 'Regeneration Fan',
  '电加热箱': 'Electric Heating Section',
  '保温风管': 'Insulated Duct',
  '转轮架组件': 'Rotor Frame Assembly',
  '尼龙网组件': 'Nylon Mesh Assembly',
  '翅片': 'Fin',
  '换热器': 'Heat Exchanger',
  '盘管': 'Coil',
  '接水盘': 'Drain Pan',
  '水盘': 'Drain Pan',
  '中效': 'Medium Efficiency',
  '初效': 'Pre-efficiency',
  '亚高效': 'Sub-high Efficiency',
  '高效': 'HEPA',
  '加湿器': 'Humidifier',
  '电加热': 'Electric Heating',
  '电预热': 'Electric Preheat',
  '电风机': 'Electric Fan',
  '前段': 'Front-Section',
  '后段': 'Rear-Section',
  '上层': 'Upper',
  '下层': 'Lower',
  '涡旋式': 'Scroll',
  '外挂': 'External',
  '水箱': 'Water Tank',
  '水泵': 'Water Pump',
  '离心泵': 'Centrifugal Pump',
  'Y型过滤器': 'Y-Strainer',
  '电机': 'Motor',
  '风机': 'Supply Fan',   // 客户标准：风机 = Supply Fan
  '变频器': 'VFD',
  '变频柜': 'VFD Cabinet',
  '电控箱': 'Electrical Control Box',
  '电箱': 'Electric Box',
  '接线盒': 'Junction Box',
  '线槽': 'Wire Duct',
  '线槽盖': 'Wire Duct Cover',
  '控制柜': 'Control Cabinet',
  '控制线': 'Control Wiring',
  '传感器': 'Sensor',
  '压力表': 'Pressure Gauge',
  '压力变送器': 'Pressure Transmitter',
  '水流开关': 'Flow Switch',
  '高低压开关': 'High/Low Pressure Switch',
  '视液镜': 'Sight Glass',
  '视镜': 'Sight Glass',
  '温度探头': 'Temperature Probe',
  '液位传感器': 'Level Sensor',
  '液位筒': 'Level Cylinder',
  '引射器': 'Ejector',
  '引射泵': 'Ejector Pump',
  '消声器': 'Silencer',
  '减震器': 'Shock Absorber',
  '减震架': 'Shock Mount',
  '橡胶软接': 'Rubber Flexible Joint',
  '橡胶垫': 'Rubber Pad',
  '膨胀节': 'Expansion Joint',
  '均流网': 'Flow Equalizing Screen',
  '均流孔板': 'Flow Equalizing Plate',
  '挡水板': 'Water Baffle',
  '挡风板': 'Baffle Plate',
  '护网': 'Guard Mesh',
  '尼龙网': 'Nylon Mesh',
  '滤网': 'Filter Mesh',
  '保温板': 'Insulation Panel',
  '岩棉板': 'Rock Wool Panel',
  '镀锌板': 'Galvanized Plate',
  '钢板': 'Steel Plate',
  '钣金': 'Sheet Metal',
  '封板': 'Sealing Plate',
  '密封板': 'Sealing Plate',
  '盖板': 'Cover Plate',
  '底板': 'Bottom Plate',
  '底面板': 'Bottom Panel',
  '顶面板': 'Top Panel',
  '侧板': 'Side Plate',
  '面板': 'Panel',
  '端板': 'End Plate',
  '侧端板': 'Side End Plate',
  '加强板': 'Reinforcing Plate',
  '加强梁': 'Reinforcing Beam',
  '加强筋': 'Stiffener',
  '支撑板': 'Support Plate',
  '支撑梁': 'Support Beam',
  '支撑架': 'Support Frame',
  '连接板': 'Connecting Plate',
  '连接件': 'Connector',
  '固定板': 'Fixing Plate',
  '固定件': 'Fixing Part',
  '安装板': 'Mounting Plate',
  '立柱': 'Column',
  '支撑立柱': 'Support Column',
  '中立柱': 'Middle Column',
  '四角立柱': 'Corner Column',
  '角立柱': 'Corner Column',
  '槽钢': 'Channel Steel',
  '角钢': 'Angle Steel',
  '角铁': 'Angle Iron',
  '方通': 'Square Tube',
  '扁通': 'Flat Tube',
  '横梁': 'Cross Beam',
  '纵梁': 'Longitudinal Beam',
  '竖梁': 'Vertical Beam',
  '中梁': 'Middle Beam',
  '顶横梁': 'Top Cross Beam',
  '顶纵梁': 'Top Longitudinal Beam',
  '中间横梁': 'Middle Cross Beam',
  '下支撑': 'Lower Support',
  '中间支撑梁': 'Middle Support Beam',
  '中支撑梁': 'Middle Support Beam',
  '斜撑': 'Diagonal Brace',
  '吊耳': 'Lifting Lug',
  '检修门': 'Access Door',
  '门板': 'Door Panel',
  '门板铰链': 'Door Hinge',
  '整板门': 'Full Panel Door',
  '柜门': 'Cabinet Door',
  '把手': 'Handle',
  '铰链': 'Hinge',
  '排水管': 'Drain Pipe',
  '补水管': 'Make-up Water Pipe',
  '供水管': 'Water Supply Pipe',
  '出水管': 'Water Outlet Pipe',
  '进水管': 'Water Inlet Pipe',
  '接管': 'Connector Tube',
  '水口': 'Water Port',
  '水口卡箍': 'Water Port Clamp',
  '卡式风机盘管模型': 'Fan Coil Unit Model',
  '框架': 'Frame',
  '滑槽': 'Slide Channel',
  '铰链': 'Hinge',
  '焊接口': 'Weld Joint',
  '焊接块': 'Weld Block',
  '焊接件': 'Welded Part',
  '螺纹': 'Thread',
  '内螺纹': 'Internal Thread',
  '外螺纹': 'External Thread',
  '内外螺纹': 'Internal/External Thread',
  '中间': 'Middle',
  '对称': 'Symmetrical',
  '默认': 'Default',
  '按加工': 'As Machined',
  '开孔': 'Opening',
  '组件': 'Assembly',
  '零件': 'Part',
  '总成': 'Assembly',
  '护网': 'Guard Mesh',
  '手动风阀': 'Manual Air Damper',
  '风阀': 'Air Damper',
  '出风口': 'Air Outlet',
  '送风': 'Supply Air',
  '排风': 'Exhaust Air',
  '进风': 'Intake Air',
  '密封条': 'Seal Strip',
  '观察窗': 'Observation Window',
  '浮球开关': 'Float Switch',
  '视液镜接口': 'Sight Glass Port',
  '边线-法兰': 'Edge Flange',
  '基体-法兰': 'Base Flange',
  '切除-旋转': 'Cut-Revolve',
  '凸台-拉伸': 'Boss-Extrude',
  '切除-拉伸': 'Cut-Extrude',
  '扫描-薄件': 'Thin Sweep',
  '阵列(线性)': 'Linear Pattern',
  '阵列(圆周)': 'Circular Pattern',
  '拉伸-薄壁': 'Thin Extrude',
  '移动面': 'Move Face',
  '删除面': 'Delete Face',
  '加强筋': 'Stiffener',
  '盘管U管': 'Coil U-Tube',
  '侧端板': 'Side End Plate',
  '端板': 'End Plate',
  '直管': 'Straight Tube',
  '弯头': 'Elbow',
  '圆角': 'Fillet',
  '倒角': 'Chamfer',
  '抽壳': 'Shell',
  '加厚': 'Thicken',
  '折叠': 'Fold',
  '放样': 'Loft',
  '扫描': 'Sweep',
  '镜向': 'Mirror',
  '输入': 'Import',
  '分液头': 'Distributor',
  '亲水性': 'Hydrophilic',
  '铝箔': 'Aluminum Foil',
  '气液分离器': 'Accumulator',
  '固定支架': 'Fixing Bracket',
  '固定三角板': 'Triangle Fixing Plate',
  '外侧封板': 'Outer Sealing Plate',
  '封板': 'Sealing Plate',
  '加强板': 'Reinforcing Plate',
  '横梁': 'Cross Beam',
  '气管': 'Gas Pipe',
  '平衡管': 'Equalizer Tube',
  '接管': 'Connector',
  '电箱': 'Electric Box',
  '机组': 'Unit',
  '底座': 'Base',
  '铝箔': 'Aluminum Foil',
  '三角': 'Triangle',
  '抓头': 'Claw',
  '固定': 'Fixing',
  '镜向': 'Mirrored',
  '顶部': 'Top',
  '外侧': 'Outer',
  '前后': 'Front/Rear',
  '亲水性': 'Hydrophilic',
  '盘管': 'Coil',
  '加强': 'Reinforcing',
  '薄件': 'Thin Part',
  '模具': 'Mold',
  '标准': 'Standard',
  '线性': 'Linear',
  '圆周': 'Circular',
  '凸台': 'Boss',
  '切除': 'Cut',
  '拉伸': 'Extrude',
  '旋转': 'Revolve',
  '输入': 'Import',
  '边线': 'Edge',
  '法兰': 'Flange',
  '阵列': 'Pattern',
  '倒角': 'Chamfer',
  '圆角': 'Fillet',
  '移动': 'Move',
  '复制': 'Copy',
  '镜向': 'Mirror',
  '侧端': 'Side End',
  '端板': 'End Plate',
  '上': 'Upper',
  '下': 'Lower',
  '左': 'Left',
  '右': 'Right',
  '前': 'Front',
  '后': 'Rear',
  '侧': 'Side',
  '进': 'In',
  '出': 'Out',
  '板': 'Plate',
  '管': 'Tube'
}

// 通用中文部件名 → 英文兜底（按词典长词优先逐词替换）
export function enPartNameFallback(zh) {
  const text = String(zh || '').trim()
  if (!text) return text
  // 标准表放最后：同一个词条它说了算（逐词替换时也会优先挑到最长的标准词）
  const dict = { ...PART_NAMES_EN, ...FEATURE_WORDS_EN, ...PART_GLOSSARY_EN }
  const tokens = Object.keys(dict).filter((k) => /[\u4e00-\u9fff]/.test(k)).sort((a, b) => b.length - a.length)
  let out = text
  for (const tk of tokens) {
    if (!out.includes(tk)) continue
    out = out.split(tk).join(' ' + dict[tk] + ' ')
  }
  return out.replace(/\s{2,}/g, ' ').trim()
}

// 英文模式下的部件显示名：先取 <部件名>-<建模特征> 的真实部件名，再精确映射或词典兜底
export function enDisplayName(zh) {
  const raw = String(zh || '').trim()
  const clean = raw.startsWith('<')
    ? ((raw.match(/^<([^<>]*)>/) || [])[1] || raw).trim()
    : raw
  return PART_GLOSSARY_EN[clean] || PART_GLOSSARY_EN[raw] ||
    PART_NAMES_EN[clean] || PART_NAMES_EN[raw] || enPartNameFallback(clean || raw)
}

let currentLang = 'zh'
// 产品视频文件名里的中文名 → 英文（文件名是中文写的，界面切英文时要跟着翻译）
export const VIDEO_NAMES_EN = {
  '气悬浮变频冷水机组': 'Air-Suspension Variable-Frequency Chiller',
  '一体式蒸发冷冷水机': 'Integrated Evaporative-Cooled Chiller',
  '风冷直膨恒温恒湿卧式': 'Air-Cooled DX Constant-Temp. & Humidity (Horizontal)',
  '风冷直膨式恒温恒湿机组': 'Air-Cooled DX Constant-Temp. & Humidity Unit',
  '药品阴凉库专用机': 'Pharmacy Cool-Storage Unit',
  '欧博空调组合柜3D产品': 'OBAIR AHU 3D Product Tour',
  '组合式空调机组': 'Modular Air Handling Unit',
  '医用空调机组': 'Medical Air-Conditioning Unit',
  '柜式风机盘管': 'Cabinet Fan Coil Unit',
  '模块式风冷冷水（热泵）机': 'Modular Air-Cooled Chiller (Heat Pump)',
  '四管制风冷螺杆机': 'Four-Pipe Air-Cooled Screw Chiller',
  '满液式水冷螺杆机讲解': 'Flooded Water-Cooled Screw Chiller Walkthrough',
  '螺杆式水冷低温冷冻机组讲解': 'Screw-Type Water-Cooled Low-Temperature Chiller Walkthrough',
  // 英文版视频（文件名形如 47_EN_xxx）
  '英文版柜式风机盘管': 'Cabinet Fan Coil Unit (EN)',
  '四管制风冷螺杆-英文': 'Four-Pipe Air-Cooled Screw Chiller (EN)',
  '满液式水冷英文': 'Flooded Water-Cooled Screw Chiller (EN)'
}

/** 视频显示名：优先用对照表，其次按部位词表逐词翻译，翻不动就保留原名 */
export function enVideoName(name) {
  const raw = String(name || '').trim()
  if (!raw) return raw
  if (VIDEO_NAMES_EN[raw]) return VIDEO_NAMES_EN[raw]
  if (PRODUCT_NAMES_EN[raw]) return PRODUCT_NAMES_EN[raw]
  return enPartNameFallback(raw) || raw
}
// 默认语言按站点分流：showroom.oubokt.net（海外站）默认英文，
// showroom.oubokt.com（国内站）默认中文。
// pf-lang-user 只在用户手动点过"中/EN"后写入，所以手动选择会一直保留；
// 旧版本只写过 pf-lang，这里不再拿它当"用户明确选择"，避免老缓存把 .net 锁成中文。
function defaultLangForHost() {
  try {
    return /(^|\.)oubokt\.net$/i.test(location.hostname) ? 'en' : 'zh'
  } catch {
    return 'zh'
  }
}
try {
  const picked = localStorage.getItem('pf-lang-user')
  currentLang = picked === 'en' || picked === 'zh' ? picked : defaultLangForHost()
} catch {
  currentLang = defaultLangForHost()
}

export function getLang() {
  return currentLang
}

export function setLang(lang) {
  currentLang = lang === 'en' ? 'en' : 'zh'
  try {
    localStorage.setItem('pf-lang', currentLang)
    localStorage.setItem('pf-lang-user', currentLang)
  } catch {}
}

export function t(key) {
  const entry = TRANSLATIONS[key]
  if (!entry) return key
  return entry[currentLang] || entry.zh || key
}
